module.exports = __webpack_public_path__ + "files/9aeeb6e56710f240fd738919b6a32dd1.png";